import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import beaconLogo from 'assets/BeaconLogo.svg';
import slackIcon from 'assets/slack_logo.svg';

import { Button } from 'Components/Button';

import { setUserProfile } from 'Redux/Actions/userActions';

import SlackService from 'services/slack';

import styles from './styles.module.scss';

export const LogIntoSlack = () => {
  const dispatch = useDispatch();

  const [isConnecting, setIsConnecting] = useState(false);

  const authUser = useSelector(state => state.userStore);

  useEffect(
    () => {
      // function to call api to fetch user details
      if (isConnecting && authUser && authUser.uuid) {
        dispatch(setUserProfile(authUser));
      }
    },
    [isConnecting, authUser]
  );

  return (
    <>
      <div className={styles['icon-container']}>
        <img src={slackIcon} alt="slack icon" className={styles['icon']} />
        <FontAwesomeIcon icon={faPlus} />
        <img src={beaconLogo} alt="onBeacon Logo" className={styles['icon']} />
      </div>
      <h2 className={styles['heading']}>
        Connect to Slack
      </h2>
      <p className={styles['text']}>
        To connect to your Slack message thread, please grant DesignPro access to your Slack workspace.
      </p>
      <Button className={styles['button']} onClick={handleSlackConnect}>
        {isConnecting ? 'Connecting to slack...' : 'Connect to Slack workspace'}
      </Button>
    </>
  );

  function handleSlackConnect() {
    setIsConnecting(true);
    localStorage.setItem('connectingToSlack', true);
    SlackService.getSlackOAuthLink()
      .then(link => {
        location.href = link;
      });
  }
};
